import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/TipiLesnic.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox'

class TipiLesnic extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Храним состояние lightbox для каждого элемента отдельно
      lightboxControllers: {}
    }
  }

  openLightbox = (elementIndex, imageIndex = 0) => {
    this.setState({
      lightboxControllers: {
        ...this.state.lightboxControllers,
        [elementIndex]: {
          toggler: !this.state.lightboxControllers[elementIndex]?.toggler,
          slide: imageIndex + 1
        }
      }
    })
  }

  closeLightbox = (elementIndex) => {
    this.setState({
      lightboxControllers: {
        ...this.state.lightboxControllers,
        [elementIndex]: {
          toggler: false,
          slide: 1
        }
      }
    })
  }

  render() {
    const { list, title, rtext, margin } = this.props
    const { lightboxControllers } = this.state

    return (
      <section className={margin != `` ? `${styles.section} ${styles[margin]}` : `${styles.section}`}>
        <Container>
          {title != '' &&
            <WhiteBlockTitle
              title={title}
              text={rtext}
            />
          }

          <div className={`${styles.list}`}>
            {list.map((elm, elementIndex) => {
              const lightboxController = lightboxControllers[elementIndex] || { toggler: false, slide: 1 }
              const lightboxSources = elm?.images?.map(img => img.image) || []

              return (
                <div key={elementIndex} className={`${styles.block} ${styles[`w-${elm?.width}`]}`}>
                  <ClientOnlyFsLightbox
                    toggler={lightboxController.toggler}
                    sources={lightboxSources}
                    slide={lightboxController.slide}
                    onClose={() => this.closeLightbox(elementIndex)}
                  />

                  <Image 
                    src={elm?.poster} 
                    alt={elm?.name} 
                    width={1180 / 12 * elm?.width} 
                    height={143} 
                    onClick={() => this.openLightbox(elementIndex, 0)}
                    style={{cursor: 'pointer'}}
                  />
                  
                  <div className={`${styles.block_text}`}>
                    <div className={`${styles.block_sep}`} />
                    <div className={`${styles.block_name}`}>[{elm?.name}]</div>
                  </div>
                  <div className={`${styles.block_btext}`}>{elm?.text}</div>

                </div>
              )
            })}
          </div>
        </Container>
      </section>
    )
  }
}

TipiLesnic.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  rtext: PropTypes.string,
  margin: PropTypes.string
}

TipiLesnic.defaultProps = {
  list: [],
  title: ``,
  rtext: ``,
  margin: ``
}

export default TipiLesnic